import React, { useState, useEffect } from "react";
import api from "../../api";
import DialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Button, Dialog, DialogContent, TextField } from "@material-ui/core";

export default function PaymentMethodView({
  id,
  classes,
  setIsLoading,
  setOpenView,
  openView,
  shortError,
  paymentMethods,
}) {
  const [defaultValues, setDefaultValues] = useState();

  useEffect(() => {
    getPaymentMethod(id);
  }, []);

  const getPaymentMethod = (id) => {
    setIsLoading(true);
    api
      .getTypePaymentMethod(id)
      .then((res) => {
        let paymentMethod = res.data;
        setDefaultValues({
          id: paymentMethod.paymentMethodId,
          name: paymentMethod.paymentMethodName,
          paymentMethod: paymentMethods.find((x) => x.key == paymentMethod.paymentMethodTypeId).label,
          paymentProcessor: paymentMethod.paymentProcessorName,
          numEntityPayment: paymentMethod.sapEntityPaymentId,
          numFormPayment: paymentMethod.sapPaymentMethodId,
        });
        setIsLoading(false);
      })
      .catch((err) => {
        shortError("Ocurrió un error.");
        setIsLoading(false);
      });
  };

  return (
    <>
      {defaultValues && (
        <Dialog
          open={openView}
          onClose={() => {
            setOpenView({ open: false });
          }}
          aria-labelledby="form-dialog-title"
          fullWidth={true}
          classes={{
            paperFullWidth: classes.paperFullWidth,
          }}
        >
          <DialogTitle id="form-dialog-title">Detalle de Medio de Pago</DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              margin="dense"
              id="name"
              type="text"
              name="nombre"
              label="Nombre medio de pago"
              value={defaultValues.name}
              fullWidth
            />
          </DialogContent>
          <DialogContent>
            <TextField
              autoFocus
              margin="dense"
              id="name"
              label="Numero entidad de pago sap"
              type="number"
              name="numEntidad"
              value={defaultValues.numEntityPayment}
              fullWidth
            />
          </DialogContent>
          <DialogContent>
            <TextField
              autoFocus
              margin="dense"
              id="name"
              label="Numero forma de pago sap"
              type="number"
              name="numFormulario"
              value={defaultValues.numFormPayment}
              fullWidth
            />
          </DialogContent>
          <DialogContent>
            <TextField
              autoFocus
              margin="dense"
              id="paymentMethod"
              label="Medio de Pago"
              type="text"
              name="paymentMethod"
              value={defaultValues.paymentMethod}
              fullWidth
            />
          </DialogContent>
          <DialogActions>
            <Button
              className="c-ml-5 c-grid-btn"
              color="primary"
              onClick={() => {
                setOpenView({ open: false });
              }}
            >
              Cerrar
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
}
